import { createReducer, on } from '@ngrx/store';
import { initialRangoSalarialPerfilState } from './rango-salarial-perfil.state';
import * as RangoSalarialPerfilActions from './rango-salarial-perfil.actions';

export const rangoSalarialPerfilReducer = createReducer(
  initialRangoSalarialPerfilState,

  // Load actions
  on(RangoSalarialPerfilActions.loadRangosSalariales, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(RangoSalarialPerfilActions.loadRangosSalarialesSuccess, (state, { rangosSalariales }) => ({
    ...state,
    rangosSalariales,
    loading: false,
    error: null
  })),

  on(RangoSalarialPerfilActions.loadRangosSalarialesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  // Create actions
  on(RangoSalarialPerfilActions.createRangoSalarialPerfil, state => ({
    ...state,
    creating: true,
    error: null
  })),

  on(RangoSalarialPerfilActions.createRangoSalarialPerfilSuccess, (state, { rangoSalarial }) => ({
    ...state,
    rangosSalariales: [...state.rangosSalariales, rangoSalarial],
    creating: false,
    error: null
  })),

  on(RangoSalarialPerfilActions.createRangoSalarialPerfilFailure, (state, { error }) => ({
    ...state,
    creating: false,
    error
  })),

  // Update actions
  on(RangoSalarialPerfilActions.updateRangoSalarialPerfil, state => ({
    ...state,
    updating: true,
    error: null
  })),

  on(RangoSalarialPerfilActions.updateRangoSalarialPerfilSuccess, (state, { rangoSalarial }) => ({
    ...state,
    rangosSalariales: state.rangosSalariales.map(r =>
      r.rangoSalarialId === rangoSalarial.rangoSalarialId ? rangoSalarial : r
    ),
    updating: false,
    error: null
  })),

  on(RangoSalarialPerfilActions.updateRangoSalarialPerfilFailure, (state, { error }) => ({
    ...state,
    updating: false,
    error
  })),

  // Selection actions
  on(RangoSalarialPerfilActions.selectRangoSalarialPerfil, (state, { rangoSalarial }) => ({
    ...state,
    selectedRangoSalarial: rangoSalarial
  })),

  // Clear actions
  on(RangoSalarialPerfilActions.clearRangoSalarialPerfilError, state => ({
    ...state,
    error: null
  })),

  on(RangoSalarialPerfilActions.clearRangoSalarialPerfilSelection, state => ({
    ...state,
    selectedRangoSalarial: null
  }))
);
